<template>
  <div>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          Génération d'étiquette
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Dashboard'}">
              <i class="fa fa-dashboard"></i>
              Accueil
            </router-link>
          </li>
          <li><a href="#">Outils</a></li>
          <li class="active">Génération étiquettes</li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingEtiquette">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Etiquette</h3>
              </div><!-- /.box-header -->
              <div class="box-body">
                <div class="row" style="margin-top: 15px;">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label for="texteCourrier">Texte de l'étiquette</label>
                      <quillEditor ref="courrierTexte"
                                   v-model="content"
                                   :options="editorOption">
                      </quillEditor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <p class="text-light-blue pull-left">
                  <i class="fa fa-warning"></i>
                  Attention de bien vérifier la hauteur de votre texte par rapport aux étiquettes</p>
                <button
                  @click="generateEtiquette()"
                  :disabled="generatingEtiquette"
                  type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                  <i class="fa fa-download"></i> Générer les étiquettes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  </div>
</template>

<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'

import {quillEditor} from 'vue-quill-editor'

require('../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

var FileSaver = require('file-saver');
var moment = require('moment')
var _ = require('underscore')

export default {
  data() {
    return {
      name: 'base-example',
      generatingEtiquette: false,
      editorOption: {},
      objet: null,
      content: '',
      config: {
        toolbar:
          [
            {
              name: 'document',
              items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates']
            },
            {
              name: 'clipboard',
              items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo']
            },
            '/',
            {
              name: 'basicstyles',
              items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat']
            },
            {
              name: 'paragraph',
              items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
            },
            {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
            {
              name: 'insert',
              items: ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak']
            },
            '/',
            {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
            {name: 'colors', items: ['TextColor', 'BGColor']},
            {name: 'tools', items: ['Maximize', 'ShowBlocks']}
          ],
        height: 300,
      }
    }
  },
  methods: {
    ...mapActions({
      majUserSelected: "majUserSelected",
      majClubSelected: "majClubSelected",
      removeUserSelected: "removeUserSelected",
      removeClubSelected: "removeClubSelected",
    }),

    replaceAll: function (str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
    },
    generateEtiquette: function () {
      let self = this;
      this.generatingEtiquette = true
      this.$http.post
      (
        self.getRoute('Secretariat.etiquetteIndividuelleClubForFlyerWithPersoText'),
        JSON.stringify({
          text: self.content != null ? this.replaceAll(self.content, '\n', '<br/>') : "",
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.generatingEtiquette = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Etiquettes_" + _.random(0, 100) + ".pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.generatingEtiquette = false
      });

    },

  },
  computed: {
    ...mapGetters({
      getUserSelected: 'getUserSelected',
      getClubSelected: 'getClubSelected',
      getRoute: 'getRoute'
    }),
    editor() {
      return this.$refs.myTextEditor.quill
    }
  },
  components: {
    quillEditor,
  },
  watch: {},
  mounted() {
    var these = this
    this.$nextTick(function () {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outils/GenerationEtiquetteFlyer.vue